import { useState, useEffect } from "react";
import { getMyFees } from "@/api/profile.api";
import type { MyFee } from "@/types/profile.types";

export function useMyFees() {
  const [fees, setFees] = useState<MyFee[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setIsLoading(true);
    getMyFees()
      .then(setFees)
      .catch((e) => setError(e as Error))
      .finally(() => setIsLoading(false));
  }, []);

  return { fees, isLoading, error };
}
